//noinspection JSUnusedGlobalSymbols

abstract class BaseError extends Error
{
	abstract _name:string
}

export class InternalError extends BaseError
{
	//https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
	_name = 'InternalError'
}

export class ArgumentError extends InternalError
{
	_name = 'ArgumentError'
}

export class ExternalError extends BaseError
{
	_name = 'ExternalError'
}
